/* ============================================================
   Sam Photos — Animation Engine (sp-animations.js)
   Upload to: Shopify Admin → Themes → Edit code → Assets
   ============================================================ */
(function () {
  'use strict';

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sp-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('sp-visible', entry.isIntersecting);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* Run on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else {
    initReveal();
  }

  /* Re-run when Shopify editor loads / reorders a section */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  document.addEventListener('shopify:section:reorder', function () { initReveal(); });
})();